export const getBadgeImageUrl = (count = 1) =>
  `https://ladderteams.imgix.net/badges/badge-${count}.png`;
